export const ALLIANZ_VARS = {
  paths: {
    D1C: 'https://t.womtp.com/slider/c/delio-lm/dfi/init.js',
    testEnviroment:
      'https://t.womtp.com/slider/d/allianz/output/main/js/bundle.js',
    customStyles: 'https://t.womtp.com/slider/c/allianz/src/css/style.css',
    customStylesTest: 'https://t.womtp.com/slider/c/allianz/src/css/style_test.css',
    wsLeadUpdate:
      'https://ws.walmeric.com/provision/wsclient/delioClientLeadId_put.html',
    iconTel: 'https://t.womtp.com/slider/c/allianz/src/img/Phone_Call_24px.png'
  },
  idTagDFI:
    '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953ad166f73ba5bb731373e838e4746a136e8ee2d1c67a22a2668b430a6a58178cbc9c5ab16bbffc5b82407cc073aa6137e1c5e1c9d61804bef1fa9c02ca98f587a6ac43f02473c9bda61f21bdc57c58fd3a',
  idTag:
    '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953ad166f73ba5bb731373e838e4746a136e8ee2d1c67a22a2668b430a6a58178cbc080cf2d1786ca6b1085b7781e2e28b79e6eb2e3cd39bbb670b21c1ee6b150d9d1cb398ca0e7dfb25d594510dbe08a665',
  defaultPhone: '919498356'
}

export const MEDIA_QUERIES = {
  mobile: 640,
  tablet: 768,
  desktop: 1024,
  xl: 1280,
  xxl: 1536
}

export const DICTIONARY_CONFIG = {
  serviceName: 'https://ws.walmeric.com/provision/wsVars/getVar.html?',
  idTag: `idTag=${ALLIANZ_VARS.idTag}`,
  dictionaryName: '&name=ALLIANZ_ES_TEST_url_SHA1_SHA1'
}



export const REGEX = Object.freeze({
  JUST_LETTERS: /^[a-zA-Z\s]+$/,
  JUST_LETTERS_WITH_SPECIALS: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s'’\-]+$/,
  JUST_NUMBERS: /^[0-9]+$/,
  NATIONAL_PHONE: /^[6-9]\d{8}$/,
  GERMAN_PHONE: /^[1-9]\d{1,4}(\d{6,10})$/,
  UK_PHONE: /^(?:(?:(?:7[0-9])|(?:8[0-9])|(?:2[0-9]))\d{8})$/,
  FRENCH_PHONE: /^\d{1,3}(?:\.\d{3})*(?:,\d+)?$/,
  BELGIAN_PHONE: /^0[1-9](?:\d{8}|\d{1}(\s?\d{3}){2})$/,
  DANISH_PHONE: /^\s?(\d{2}\s?\d{2}\s?\d{2}\s?\d{2}|\d{8})$/,
  IRISH_PHONE: /^[1-9]\d{1,}([ -]?\d{1,}){6}$/,
  NORWEGIAN_PHONE: /^\s?([2-9]\d{1,7})$/,
  SWEDISH_PHONE: /^\s?0?[1-9]\d{1,7}$/,
  DUTCH_PHONE: /^\s?[1-9]\d{8}$/,
  SWISS_PHONE: /^\s?0[1-9]\d{1,8}$/,
  AUSTRIAN_PHONE: /^\s?0[1-9]\d{8}$/,
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  DNI: /^[0-9]{8}[A-Z]$/i,
  NIE: /^[XYZ][0-9]{7}[A-Z]$/i,
  DEVICES: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
  // eslint-disable-next-line no-control-regex
  CHARACTERS_NOT_VISIBLE: /[\x00-\x1F\x7F-\x9F]/

})

export const FEEDBACK_MESSAGES = Object.freeze({
  ERROR: {
    NAME_REQUIRED: 'el nombre es obligatorio',
    NAME_REQUIRED_EN: 'name is required',
    NAME_REQUIRED_DE: 'Name ist erforderlich',
    NAME_REQUIRED_FR: 'Le nom est requis',
    NAME_INVALID: 'el formato de nombre no es válido',
    NAME_INVALID_EN: 'the name format is invalid',
    NAME_INVALID_DE: 'Das Namensformat ist ungültig',
    NAME_INVALID_FR: 'Le format du nom n est pas valide',
    PHONE_REQUIRED: 'el teléfono es obligatorio',
    PHONE_REQUIRED_EN: 'telephone is required',
    PHONE_REQUIRED_DE: 'Das Telefon ist obligatorisch',
    PHONE_REQUIRED_FR: 'Le téléphone est obligatoire',
    PHONE_INVALID:
      'introducir teléfono nacional. Números extranjeros, llamar al teléfono indicado más abajo',
    PHONE_INVALID_EN:
      'invalid telephone. Please enter a correct number',
    PHONE_INVALID_DE:'Ungültige Telefonnummer. Bitte geben Sie eine korrekte Nummer ein',
    PHONE_INVALID_FR:'Numéro de téléphone invalide. Veuillez entrer un numéro correct',
    EMAIL_INVALID: 'el email no es válido',
    EMAIL_INVALID_EN: 'email is invalid',
    EMAIL_INVALID_DE: 'Die E-Mail ist ungültig',
    EMAIL_INVALID_FR: 'L e-mail n est pas valide',
    EMAIL_REQUIRED_EN: 'email is required',
    EMAIL_REQUIRED_DE: 'Die E-Mail ist ungültig',
    EMAIL_REQUIRED_FR: 'L e-mail n est pas valide',
    SELECT_THE_SCHEDULE: 'seleccione el horario',
    SELECT_THE_SCHEDULE_EN: 'select the schedule',
    SELECT_THE_SCHEDULE_DE: 'Wähle eine Uhrzeit',
    SELECT_THE_SCHEDULE_FR: 'Choisissez une heure',
    SELECT_CLIENT_TYPE: 'selecciona si eres cliente',
    SELECT_CLIENT_TYPE_EN: 'select if you are a customer',
    SELECT_CLIENT_TYPE_DE: 'Wählen Sie aus, ob Sie Kunde sind',
    SELECT_CLIENT_TYPE_FR: 'Choisissez si vous êtes client',
    DNI_REQUIRED: 'el número de documento es obligatorio',
    DNI_REQUIRED_EN: 'document number is required',
    DNI_REQUIRED_DE: 'document number is required',
    DNI_REQUIRED_FR: 'le numéro de document est requis',
    DNI_INVALID: 'el formato del documento es incorrecto',
    DNI_INVALID_EN: 'document format is incorrect',
    DNI_INVALID_DE: 'Das Dokumentformat ist falsch',
    DNI_INVALID_FR: 'Le format du document est incorrect',
    PRIVACY_POLICY: 'acepta la política de privacidad',
    PRIVACY_POLICY_EN: 'accept the privacy policy',
    PRIVACY_POLICY_DE: 'Akzeptieren Sie die Datenschutzbestimmungen',
    PRIVACY_POLICY_FR: 'Acceptez la politique de confidentialité'
  },
  HOURS: {
    OFFICE_OFF:
      'Solo teléfonos nacionales. Números internacionales, contactar de 9 a 20h',
    OFFICE_OFF_EN:
      'Other foreign numbers, call during the hours indicated below',
    OFFICE_OFF_DE:
      'Ungültige Telefonnummer. Bitte geben Sie eine korrekte Nummer ein',
      OFFICE_OFF_FR:
      'Numéro de téléphone invalide. Veuillez entrer un numéro correct',
  },
  SUCCESS: {}
})

export const ADD_LEAD_ENDPOINT =
  'https://ws.walmeric.com/provision/wsclient/client_addlead.html'

const CONVERSION_TAGS = []

export const DECLARATIVE_TAGS = Object.freeze({
  format: 'jsonp',
  verifyLeadId: 'NO',
  idTag:
    '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953ad166f73ba5bb731373e838e4746a136e8ee2d1c67a22a2668b430a6a58178cbc080cf2d1786ca6b1085b7781e2e28b79e6eb2e3cd39bbb670b21c1ee6b150d9d1cb398ca0e7dfb25d594510dbe08a665',
  userAgent: window.navigator.userAgent,
  EConversion: JSON.stringify(CONVERSION_TAGS)


})

export const DECLARATIVE_TAGS_EN = Object.freeze({
  format: 'jsonp',
  verifyLeadId: 'NO',
  idTag:
    '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953ad166f73ba5bb731373e838e4746a136e8ee2d1c67a22a2668b430a6a58178cbc080cf2d1786ca6b1085b7781e2e28b79e6eb2e3cd39bbb670b21c1ee6b150d9d1cb398ca0e7dfb25d594510dbe08a665',
  userAgent: window.navigator.userAgent,
  EXPAT: 'English',
  EConversion: JSON.stringify(CONVERSION_TAGS)
})

export const DECLARATIVE_TAGS_AL = Object.freeze({
  format: 'jsonp',
  verifyLeadId: 'NO',
  idTag:
    '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953ad166f73ba5bb731373e838e4746a136e8ee2d1c67a22a2668b430a6a58178cbc080cf2d1786ca6b1085b7781e2e28b79e6eb2e3cd39bbb670b21c1ee6b150d9d1cb398ca0e7dfb25d594510dbe08a665',
  userAgent: window.navigator.userAgent,
  EXPAT: 'Aleman',
  EConversion: JSON.stringify(CONVERSION_TAGS)
})
export const DECLARATIVE_TAGS_FR = Object.freeze({
  format: 'jsonp',
  verifyLeadId: 'NO',
  idTag:
    '29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953ad166f73ba5bb731373e838e4746a136e8ee2d1c67a22a2668b430a6a58178cbc080cf2d1786ca6b1085b7781e2e28b79e6eb2e3cd39bbb670b21c1ee6b150d9d1cb398ca0e7dfb25d594510dbe08a665',
  userAgent: window.navigator.userAgent,
  EXPAT: 'frances',
  EConversion: JSON.stringify(CONVERSION_TAGS)
})

export const URL_WITHOUT_RINGPOOL = ['https://www.allianz.es/contacto.html']

export const URL_WITHOUT_DMV = [
  'https://www.allianz.es/forms/tellamamos-agente.html'
]

export const URL_FOR_GENERATE_LEAD_TAG = [
  'https://www.allianz.es/'
]

export const URL_VISITED = window.location.origin + window.location.pathname

export const PREFIX_PHONE_LIST = {
  SPAIN_PHONE: '+34',
  GERMAN_PHONE: '+49',
  UK_PHONE: '+44',
  FRENCH_PHONE: '+33',
  BELGIAN_PHONE: '+32',
  DANISH_PHONE: '+45',
  IRISH_PHONE: '+353',
  NORWEGIAN_PHONE: '+47',
  SWEDISH_PHONE: '+46',
  DUTCH_PHONE: '+31',
  SWISS_PHONE: '+41',
  AUSTRIAN_PHONE: '+43',
  // AFGHANISTAN_PHONE: '+93',
  // ALBANIA_PHONE: '+355',
  // ALGERIA_PHONE: '+213',
  // ANDORRA_PHONE: '+376',
  // ANGOLA_PHONE: '+244',
  // ANGUILLA_PHONE: '+1 264',
  // ANTARCTICA_PHONE: '+672',
  // ANTIGUA_AND_BARBUDA_PHONE: '+1 268',
  // SAUDI_ARABIA_PHONE: '+966',
  // ARGENTINA_PHONE: '+54',
  // ARMENIA_PHONE: '+374',
  // ARUBA_PHONE: '+297',
  // AUSTRALIA_PHONE: '+61',
  // AUSTRIA_PHONE: '+43',
  // AZERBAIJAN_PHONE: '+994',
  // BELGIUM_PHONE: '+32',
  // BAHAMAS_PHONE: '+1 242',
  // BAHRAIN_PHONE: '+973',
  // BANGLADESH_PHONE: '+880',
  // BARBADOS_PHONE: '+1 246',
  // BELIZE_PHONE: '+501',
  // BENIN_PHONE: '+229',
  // BHUTAN_PHONE: '+975',
  // BELARUS_PHONE: '+375',
  // MYANMAR_PHONE: '+95',
  // BOLIVIA_PHONE: '+591',
  // BOSNIA_AND_HERZEGOVINA_PHONE: '+387',
  // BOTSWANA_PHONE: '+267',
  // BRAZIL_PHONE: '+55',
  // BRUNEI_PHONE: '+673',
  // BULGARIA_PHONE: '+359',
  // BURKINA_FASO_PHONE: '+226',
  // BURUNDI_PHONE: '+257',
  // CAPE_VERDE_PHONE: '+238',
  // CAMBODIA_PHONE: '+855',
  // CAMEROON_PHONE: '+237',
  // CANADA_PHONE: '+1',
  // CHAD_PHONE: '+235',
  // CHILE_PHONE: '+56',
  // CHINA_PHONE: '+86',
  // CYPRUS_PHONE: '+357',
  // VATICAN_CITY_STATE_PHONE: '+39',
  // COLOMBIA_PHONE: '+57',
  // COMOROS_PHONE: '+269',
  // REPUBLIC_OF_THE_CONGO_PHONE: '+242',
  // DEMOCRATIC_REPUBLIC_OF_THE_CONGO_PHONE: '+243',
  // NORTH_KOREA_PHONE: '+850',
  // SOUTH_KOREA_PHONE: '+82',
  // IVORY_COAST_PHONE: '+225',
  // COSTA_RICA_PHONE: '+506',
  // CROATIA_PHONE: '+385',
  // CUBA_PHONE: '+53',
  // CURACAO_PHONE: '+5999',
  // DENMARK_PHONE: '+45',
  // DOMINICA_PHONE: '+1 767',
  // ECUADOR_PHONE: '+593',
  // EGYPT_PHONE: '+20',
  // EL_SALVADOR_PHONE: '+503',
  // UNITED_ARAB_EMIRATES_PHONE: '+971',
  // ERITREA_PHONE: '+291',
  // SLOVAKIA_PHONE: '+421',
  // SLOVENIA_PHONE: '+386',
  // UNITED_STATES_OF_AMERICA_PHONE: '+1',
  // ESTONIA_PHONE: '+372',
  // ETHIOPIA_PHONE: '+251',
  // PHILIPPINES_PHONE: '+63',
  FINLAND_PHONE: '+358',
  // FIJI_PHONE: '+679',
  // FRANCE_PHONE: '+33',
  // GABON_PHONE: '+241',
  // GAMBIA_PHONE: '+220',
  // GEORGIA_PHONE: '+995',
  // GHANA_PHONE: '+233',
  // GIBRALTAR_PHONE: '+350',
  // GRENADA_PHONE: '+1 473',
  // GREECE_PHONE: '+30',
  // GREENLAND_PHONE: '+299',
  // GUADELOUPE_PHONE: '+590',
  // GUAM_PHONE: '+1 671',
  // GUATEMALA_PHONE: '+502',
  // FRENCH_GUIANA_PHONE: '+594',
  // GUERNSEY_PHONE: '+44',
  // GUINEA_PHONE: '+224',
  // EQUATORIAL_GUINEA_PHONE: '+240',
  // GUINEA_BISSAU_PHONE: '+245',
  // GUYANA_PHONE: '+592',
  // HAITI_PHONE: '+509',
  // HONDURAS_PHONE: '+504',
  // HONG_KONG_PHONE: '+852',
  // HUNGARY_PHONE: '+36',
  // INDIA_PHONE: '+91',
  // INDONESIA_PHONE: '+62',
  // IRAN_PHONE: '+98',
  // IRAQ_PHONE: '+964',
  // IRELAND_PHONE: '+353',
  // ISLE_OF_MAN_PHONE: '+44',
  // CHRISTMAS_ISLAND_PHONE: '+61',
  // NORFOLK_ISLAND_PHONE: '+672',
  // ICELAND_PHONE: '+354',
  // BERMUDA_ISLANDS_PHONE: '+1 441',
  // CAYMAN_ISLANDS_PHONE: '+1 345',
  // COCOS_KEELING_ISLANDS_PHONE: '+61',
  // COOK_ISLANDS_PHONE: '+682',
  // ALAND_ISLANDS_PHONE: '+358',
  // FAROE_ISLANDS_PHONE: '+298',
  // SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS_PHONE: '+500',
  // HEARD_ISLAND_AND_MCDONALD_ISLANDS_PHONE: 'N/A',
  // MALDIVES_PHONE: '+960',
  // FALKLAND_ISLANDS_MALVINAS_PHONE: '+500',
  // NORTHERN_MARIANA_ISLANDS_PHONE: '+1 670',
  // MARSHALL_ISLANDS_PHONE: '+692',
  // PITCAIRN_ISLANDS_PHONE: 'N/A',
  // SOLOMON_ISLANDS_PHONE: '+677',
  // TURKS_AND_CAICOS_ISLANDS_PHONE: '+1 649',
  // UNITED_STATES_MINOR_OUTLYING_ISLANDS_PHONE: '+246',
  // VIRGIN_ISLANDS_BRITISH_PHONE: '+1 284',
  // UNITED_STATES_VIRGIN_ISLANDS_PHONE: '+1 340',
  // ISRAEL_PHONE: '+972',
  // ITALY_PHONE: '+39',
  // JAMAICA_PHONE: '+1 876',
  // JAPAN_PHONE: '+81',
  // JERSEY_PHONE: '+44',
  // JORDAN_PHONE: '+962',
  // KAZAKHSTAN_PHONE: '+7',
  // KENYA_PHONE: '+254',
  // KYRGYZSTAN_PHONE: '+996',
  // KIRIBATI_PHONE: '+686',
  // KUWAIT_PHONE: '+965',
  // LEBANON_PHONE: '+961',
  // LAOS_PHONE: '+856',
  // LESOTHO_PHONE: '+266',
  // LATVIA_PHONE: '+371',
  // LIBERIA_PHONE: '+231',
  // LIBYA_PHONE: '+218',
  // LIECHTENSTEIN_PHONE: '+423',
  // LITHUANIA_PHONE: '+370',
  LUXEMBOURG_PHONE: '+352'
  // MEXICO_PHONE: '+52',
  // MONACO_PHONE: '+377',
  // MACAO_PHONE: '+853',
  // MACEDONIA_PHONE: '+389',
  // MADAGASCAR_PHONE: '+261',
  // MALAYSIA_PHONE: '+60',
  // MALAWI_PHONE: '+265',
  // MALI_PHONE: '+223',
  // MALTA_PHONE: '+356',
  // MOROCCO_PHONE: '+212',
  // MARTINIQUE_PHONE: '+596',
  // MAURITIUS_PHONE: '+230',
  // MAURITANIA_PHONE: '+222',
  // MAYOTTE_PHONE: '+262',
  // FEDERATED_STATES_OF_MICRONESIA_PHONE: '+691',
  // MOLDOVA_PHONE: '+373',
  // MONGOLIA_PHONE: '+976',
  // MONTENEGRO_PHONE: '+382',
  // MONTSERRAT_PHONE: '+1 664',
  // MOZAMBIQUE_PHONE: '+258',
  // NAMIBIA_PHONE: '+264',
  // NAURU_PHONE: '+674',
  // NEPAL_PHONE: '+977',
  // NICARAGUA_PHONE: '+505',
  // NIGER_PHONE: '+227',
  // NIGERIA_PHONE: '+234',
  // NIUE_PHONE: '+683',
  // NORWAY_PHONE: '+47',
  // NEW_CALEDONIA_PHONE: '+687',
  // NEW_ZEALAND_PHONE: '+64',
  // OMAN_PHONE: '+968',
  // NETHERLANDS_PHONE: '+31',
  // PAKISTAN_PHONE: '+92',
  // PALAU_PHONE: '+680',
  // PALESTINE_PHONE: '+970',
  // PANAMA_PHONE: '+507',
  // PAPUA_NEW_GUINEA_PHONE: '+675',
  // PARAGUAY_PHONE: '+595',
  // PERU_PHONE: '+51',
  // FRENCH_POLYNESIA_PHONE: '+689',
  // POLAND_PHONE: '+48',
  // PORTUGAL_PHONE: '+351',
  // PUERTO_RICO_PHONE: '+1',
  // QATAR_PHONE: '+974',
  // UNITED_KINGDOM_PHONE: '+44',
  // CENTRAL_AFRICAN_REPUBLIC_PHONE: '+236',
  // CZECH_REPUBLIC_PHONE: '+420',
  // DOMINICAN_REPUBLIC_PHONE: '+1 809',
  // SOUTH_SUDAN_PHONE: '+211',
  // REUNION_PHONE: '+262',
  // RWANDA_PHONE: '+250',
  // ROMANIA_PHONE: '+40',
  // RUSSIA_PHONE: '+7',
  // WESTERN_SAHARA_PHONE: '+212',
  // SAMOA_PHONE: '+685',
  // AMERICAN_SAMOA_PHONE: '+1 684',
  // SAINT_BARTHELEMY_PHONE: '+590',
  // SAINT_KITTS_AND_NEVIS_PHONE: '+1 869',
  // SAN_MARINO_PHONE: '+378',
  // SAINT_MARTIN_FRENCH_PART_PHONE: '+1 599',
  // SAINT_PIERRE_AND_MIQUELON_PHONE: '+508',
  // SAINT_VINCENT_AND_THE_GRENADINES_PHONE: '+1 784',
  // ASCENSION_AND_TRISTAN_DA_CUNHA_PHONE: '+290',
  // SAINT_LUCIA_PHONE: '+1 758',
  // SAO_TOME_AND_PRINCIPE_PHONE: '+239',
  // SENEGAL_PHONE: '+221',
  // SERBIA_PHONE: '+381',
  // SEYCHELLES_PHONE: '+248',
  // SIERRA_LEONE_PHONE: '+232',
  // SINGAPORE_PHONE: '+65',
  // SINT_MAARTEN_PHONE: '+1 721',
  // SYRIA_PHONE: '+963',
  // SOMALIA_PHONE: '+252',
  // SRI_LANKA_PHONE: '+94',
  // SOUTH_AFRICA_PHONE: '+27',
  // SUDAN_PHONE: '+249',
  // SWEDEN_PHONE: '+46',
  // SWITZERLAND_PHONE: '+41',
  // SURINAME_PHONE: '+597',
  // SVALBARD_AND_JAN_MAYEN_PHONE: '+47',
  // SWAZILAND_PHONE: '+268',
  // TAJIKISTAN_PHONE: '+992',
  // THAILAND_PHONE: '+66',
  // TAIWAN_PHONE: '+886',
  // TANZANIA_PHONE: '+255',
  // BRITISH_INDIAN_OCEAN_TERRITORY_PHONE: '+246',
  // FRENCH_SOUTHERN_TERRITORIES_PHONE: 'N/A',
  // EAST_TIMOR_PHONE: '+670',
  // TOGO_PHONE: '+228',
  // TOKELAU_PHONE: '+690',
  // TONGA_PHONE: '+676',
  // TRINIDAD_AND_TOBAGO_PHONE: '+1 868',
  // TUNISIA_PHONE: '+216',
  // TURKMENISTAN_PHONE: '+993',
  // TURKEY_PHONE: '+90',
  // TUVALU_PHONE: '+688',
  // UKRAINE_PHONE: '+380',
  // UGANDA_PHONE: '+256',
  // URUGUAY_PHONE: '+598',
  // UZBEKISTAN_PHONE: '+998',
  // VANUATU_PHONE: '+678',
  // VENEZUELA_PHONE: '+58',
  // VIETNAM_PHONE: '+84',
  // WALLIS_AND_FUTUNA_PHONE: '+681',
  // YEMEN_PHONE: '+967',
  // DJIBOUTI_PHONE: '+253',
  // ZAMBIA_PHONE: '+260',
  // ZIMBABWE_PHONE: '+263'
}

export const ORIGEN_LEAD_VALUES = {
  CALLME_HEADER_DESKTOP: 'callme header desktop',
  CALLME_DESKTOP_STICKY: 'callme desktop sticky',
  CALLME_DESKTOP_BOTON_CMS: 'callme desktop boton cms',
  CALLME_HEADER_MOBILE: 'callme header mobile',
  CALLME_MOBILE_CTA: 'callme mobile cta',
  RINGPOOL_MOBILE_CTA: 'ringpool mobile cta',
  RINGPOOL_MOBILE_MODAL: 'ringpool mobile modal',
  RINGPOOL_MOBILE_HEADER: 'ringpool mobile header',
  RINGPOOL_DESKTOP: 'ringpool desktop',
  RINGPOOL_DESKTOP_SERVICIO_INTEGRADO: 'ringpool desktop servicio integrado'
}

/**
 * * CALLME_HEADER_DESKTOP ✅
 * Se refiere a cuando se despliega la modal a través del botón “pedir presupuesto” fijado en en el header.
 *
 * * CALLME DESKTOP STICKY ✅
 * Cuando la modal es abierta a través del botón “pedir presupuesto” que se encuentra en el banner principal (Above the fold)
 *
 * * CALLME DESKTOP BOTÓN CMS ✅
 * Cuando la modal es abierta a través del resto de botones “pedir presupuesto” que se encuentra en la landing
 *
 * * CALLME HEADER MOBILE ✅
 * Se refiere a cuando se despliega la modal a través del botón “pedir presupuesto” fijado en en el header.
 *
 * * CALLME MOBILE CTA ✅
 * Se refiere a cuando se despliega la modal a través del botón “te llamamos” fijado en en el bottom.
 *
 * * RINGPOOL MOBILE CTA ✅
 * Cuando se hace un lead llamando directamente al ringpool que aparece en el botón fijado en el bottom.
 *
 * * RINGPOOL MOBILE MODAL ✅
 * Cuando se hace un lead llamando directamente al ringpool que aparece en la modal.
 *
 * * RINGPOOL MOBILE HEADER ✅
 * Cuando se hace un lead llamando directamente al ringpool que aparece en la cabecera.
 *
 * * RINGPOOL DESKTOP ✅
 * Cuando se hace un lead llamando tanto al número de la modal como al del header.
 *
 * * RINGPOOL DESKTOP SERVICIO INTEGRADO
 * Cuando se hace un lead llamando desde un ordenador.
 */

export const PHONES_TO_BLACKLIST = [
  // '638390786',
  // '635358024',
  // '915986635',
  // '611646044'
]
